import { request } from "@/http";

export const getAllNotifications = () => request({
    url: '/notifications/view?sortType=desc',
    method: 'GET'
});

export const readAllNotifications = () => request({
    url: `/notifications/readAll`,
    method: 'POST'
});